import "./Footer.scss";
import TextBlock from "../../components/ui/TextBlock";
import Button from "../../components/ui/Button";
// import strategyDeckPDF from "../../assets/BMW-WR-Digital-Programs-Strategy-Deck.pdf";
function Footer() {
	return (
		<footer>
			<div className="footer-container">
				<div className="columns-container">
					<div className="column">
						<TextBlock
							title="READY TO GET STARTED?"
							type="h1"
							align="left"
						/>

						<TextBlock
							paragraph={
								<>
									Elevate your digital presence with the 2026
									BMW Western Region Tier 3 program. Select
									your package and experience seamless,
									expert-led integration.
								</>
							}
							type="p-block"
							align="left"
						/>
					</div>
					<div className="column">
						<div className="buttons-container">
							<Button
								link="/enroll"
								styleName="blue"
								size="large">
								Enroll Now
							</Button>
							{/* <a
								href={strategyDeckPDF}
								className="button outline_white small_button"
								target="_blank"
								rel="noopener noreferrer">
								Explore the Strategy
							</a> */}
						</div>
						<TextBlock
							paragraph="*All campaigns run continuously, starting March 2026."
							type="disclaimer"
							align="center"
						/>
					</div>
				</div>
			</div>
		</footer>
	);
}

export default Footer;
